export default{
    lista:{
        method:'get',
        url:'folhar/ver/pagamento/tomador'
    },
    boletim:{
        method:'post',
        url:'folhar/ver/pagamento/tomador/boletins'
    },
}